/**
 * Back row for rebalance screens, with the strategy questionnaire menu when Exit should leave this flow.
 *
 * Belongs here: back, and the overflow button that opens the strategy menu sheet.
 * Does not belong here: rendering ExpertReviewTopBar — that reads the strategy session.
 * The overflow icon is imported from that file so both menus stay the same.
 */
import BackButton from '../../../../components/ui-components/BackButton'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { useBottomSheet } from '../../../../state-management/contexts/BottomSheetContext'
import { EventNames } from '../../../../types/misc.types'
import { lightImpactVibrate, trackEvent } from '../../../../utils/appBridge'
import { EXPERT_REVIEW_MORE_OPTIONS_ICON } from '../../expert-review/shared/components/ExpertReviewTopBar'
import { StrategyQuestionnaireMenuSheet } from '../../expert-review/strategy-questionnaire/ui/MenuSheet'
import {
  RebalanceQuestionnaireBottomSheet,
  RebalanceQuestionnaireEventIds
} from '../analytics/rebalanceQuestionnaireEvents'

export function RebalanceTopBar({
  onBack,
  onMenuExit,
  analyticsScreen,
  testLocatorBack,
  testLocatorMenu
}: {
  onBack: () => void
  onMenuExit?: () => void
  analyticsScreen: string
  testLocatorBack?: string
  testLocatorMenu?: string
}) {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  function handleMenuClick() {
    lightImpactVibrate()
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ScreenName: analyticsScreen,
        eventId: RebalanceQuestionnaireEventIds.Menu,
        buttonLabel: 'More options'
      }
    })
    openBottomSheet(
      <StrategyQuestionnaireMenuSheet
        analyticsScreen={analyticsScreen}
        sheetName={RebalanceQuestionnaireBottomSheet.Menu}
        exitEventId={RebalanceQuestionnaireEventIds.MenuExit}
        goBackEventId={RebalanceQuestionnaireEventIds.MenuGoBack}
        onDismiss={closeBottomSheet}
        onExitAssessment={() => onMenuExit?.()}
      />
    )
  }

  return (
    <div className="flex h-6 items-center justify-between">
      <BackButton
        fill="#000000"
        size={24}
        testLocator={testLocatorBack}
        onClick={() => {
          lightImpactVibrate()
          trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
              ScreenName: analyticsScreen,
              eventId: RebalanceQuestionnaireEventIds.Back,
              buttonLabel: 'Back'
            }
          })
          onBack()
        }}
      />
      {onMenuExit != null ? (
        <button
          type="button"
          onClick={handleMenuClick}
          aria-label="More options"
          className="flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center border-none bg-transparent p-0"
          {...(testLocatorMenu ? { 'test-locator': testLocatorMenu } : {})}
        >
          <RenderHTML innerHTMLText={EXPERT_REVIEW_MORE_OPTIONS_ICON} />
        </button>
      ) : (
        <span className="h-6 w-6 shrink-0" aria-hidden />
      )}
    </div>
  )
}
